import { Injectable, inject } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { UrlHelperService } from '@frontend/sports/navigation/core/feature/url-helper';
import { NavigationRouterService } from '@frontend/sports/web/navigation-data-access';

import { BreadcrumbResult, IBreadcrumbsResolve } from '../breadcrumbs/breadcrumbs.resolver';

@Injectable({ providedIn: 'root' })
export class MultiSportsBreadcrumbsResolver implements IBreadcrumbsResolve {
    private sitecore = inject(Sitecore);
    private urlHelper = inject(UrlHelperService);
    private navigationRouter = inject(NavigationRouterService);

    resolve(): BreadcrumbResult {
        const title = this.sitecore.seo;
        this.navigationRouter.setNavigation('multisportshub');
        return [
            {
                icon: 'sports-26',
                title: title.MultiSportsBreadcrumbTitle,
                url: this.urlHelper.getMultiSportsHubUrl(),
            },
        ];
    }
}
